import React, { useCallback, useEffect, useState, useContext } from 'react'
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import { SimpleTreeView } from  '@mui/x-tree-view'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import AutoRedactTreeItem from './AutoRedactTreeItem'
import { FoldersGetContents } from 'modules/Rest'
import { MessageContext } from './Contexts'
import { useIsMounted } from 'modules/Utils'

const ExpandIcon = withStyles({
  root: {
    color: '#666',
  },
})(AddIcon)

const MinimizeIcon = withStyles({
  root: {
    color: '#666',
  },
})(RemoveIcon)

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: '400px',
  },
}))

export default function AutoRedactTree({ dataRoom }) {
  const classes = useStyles()
  const [toggledNodes, setToggledNodes] = useState(null)
  const [topFolder, setTopFolder] = useState(null)
  const { messageDispatch } = useContext(MessageContext)
  const isMounted = useIsMounted()

  const fetchTopFolder = useCallback(async () => {
    setTopFolder(null)
    try {
      const { data: { folder, success, info } } = await FoldersGetContents({
        data_room: dataRoom,
        incl_folders: false,
        incl_auto_redact: true,
      })
      if (success && folder && isMounted.current) {
        setTopFolder(folder)
        setToggledNodes([folder.folder])
      } else if (!success && isMounted.current) {
        throw new Error(info ? info : 'An error occurred')
      }
    } catch (error) {
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [dataRoom, isMounted, messageDispatch])

  useEffect(() => {
    fetchTopFolder()
  }, [dataRoom, fetchTopFolder])

  const onNodeToggle = (event, nodeIds) => {
    if (event.target.tagName === 'path' || event.target.tagName === 'svg') {
      if (nodeIds.length) {
        setToggledNodes(nodeIds)
      } else {
        setToggledNodes([])
      }
    }
  }

  return (
    <div className={classes.root}>
      {topFolder && <SimpleTreeView
        slots={{
          expandIcon: ExpandIcon,
          collapseIcon: MinimizeIcon,
        }}
        onExpandedItemsChange={onNodeToggle}
        expanded={toggledNodes}
        defaultExpandedItems={[topFolder.folder]}
        expansionTrigger="iconContainer"
      >
        <AutoRedactTreeItem
          nodeId={topFolder.folder}
          folder={topFolder}
          autoload={true}
          toggledNodes={toggledNodes}
          onReload={fetchTopFolder}
        />
      </SimpleTreeView>}
    </div>
  )
}
